import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ConsentType } from '@core/services/cookie-consent/cookie-consent.config';
import { UrlHelperService } from '@core/services/url-helper.service';
import { AdtractionExtendedGlobal } from '@features/third-party/adtraction/adtraction.models';
import { OrderViewModel } from '@models/api-orders.models';
import { PlatformService } from '@core/services/platform.service';
import { ThirdPartyLoaderComponent } from '../third-party-loader/third-party-loader.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-adtraction',
    templateUrl: './adtraction.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, ThirdPartyLoaderComponent]
})
export class AdtractionComponent implements OnInit {
    public adtractionScriptUrl = '';

    @Input()
    public consent: ConsentType;

    @Input()
    public order: OrderViewModel;

    constructor(private urlHelper: UrlHelperService, private platformService: PlatformService) {}

    ngOnInit(): void {
        if (this.platformService.isServer) {
            return;
        }

        const { orderKey, totalTransactionAmountExcludingVatRaw } = this.order;
        const windowRef = window as AdtractionExtendedGlobal & typeof globalThis;

        windowRef.ADT = {
            ...(windowRef.ADT || {}),
            Tag: {
                ...(windowRef.ADT?.Tag || {}),
                t: 3,
                c: 'DKK',
                tp: 1666126667,
                am: totalTransactionAmountExcludingVatRaw,
                ti: orderKey
            }
        };

        this.adtractionScriptUrl = this.getScriptUrl(this.urlHelper.getRootDomain());
    }

    private getScriptUrl(domain: string): string {
        return `https://on.${domain}/jsTag?ap=1666126554`;
    }
}
